import {
  MOKA_MATCH_EVEN_WIN_PROBABILITY,
  MOKA_MATCH_MAXIMUM_WIN_PROBABILITY,
  MOKA_MATCH_MINIMUM_WIN_PROBABILITY,
} from "@/constants";

const getMokaBlackWinProbabilityFromValue = (gameState: MokaGameState, value: number) => {
  const currentPlayerWinProbability = Math.min(
    MOKA_MATCH_MAXIMUM_WIN_PROBABILITY,
    Math.max(
      MOKA_MATCH_MINIMUM_WIN_PROBABILITY,
      (value + MOKA_MATCH_MAXIMUM_WIN_PROBABILITY) * MOKA_MATCH_EVEN_WIN_PROBABILITY,
    ),
  );

  return gameState.nextColor === "black"
    ? currentPlayerWinProbability
    : MOKA_MATCH_MAXIMUM_WIN_PROBABILITY - currentPlayerWinProbability;
};

export { getMokaBlackWinProbabilityFromValue };
